export default __webpack_public_path__ + "static/media/Joney Resume (2).246a4f62.pdf";